// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../assets/fonts/css/fontiran.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ****Fonts**** */
/* ****Shadows (subtle elevation — flat SaaS)**** */
/* ****Border radius**** */
/* ****icon size**** */
/* **** Device width **** */
/* **** helper variable **** */
/* **** Motion **** */
html {
  /* Trafertir design tokens — professional navy + sky CTA */
  --primaryColor: #0369a1;
  --secondaryColor: #0f172a;
  --accentColor: #0284c7;
  --bgc: #f8fafc;
  --card-bgc: #ffffff;
  --surface-muted: #e8ecf1;
  --text-color: #020617;
  --text-muted: #64748b;
  --border-color: #e2e8f0;
  --ring-color: #0f172a;
  --destructive: #dc2626;
  --approved-bgc: rgba(34, 197, 94, 0.15);
  --approved-textColor: #166534;
  --pending-bgc: rgba(14, 165, 233, 0.15);
  --pending-textColor: #075985;
  --rejected-bgc: rgba(220, 38, 38, 0.15);
  --rejected-textColor: #991b1b;
  --fontFamily: "Plus Jakarta Sans", system-ui, sans-serif;
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --shadow-sm: 0 1px 2px rgba(15, 23, 42, 0.05);
  --shadow-md: 0 1px 2px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.06);
  --transition: 200ms cubic-bezier(0.16, 1, 0.3, 1);
}

html[theme=dark] {
  --primaryColor: #38bdf8;
  --secondaryColor: #e2e8f0;
  --accentColor: #7dd3fc;
  --bgc: #0f172a;
  --card-bgc: #1e293b;
  --surface-muted: #334155;
  --text-color: #f8fafc;
  --text-muted: #94a3b8;
  --border-color: #334155;
  --ring-color: #38bdf8;
  --approved-bgc: rgba(34, 197, 94, 0.22);
  --approved-textColor: #bbf7d0;
  --pending-bgc: rgba(56, 189, 248, 0.22);
  --pending-textColor: #bae6fd;
  --rejected-bgc: rgba(248, 113, 113, 0.22);
  --rejected-textColor: #fecaca;
}

html[dir=rtl] {
  --fontFamily: iranyekan, "IRANSans", "Tahoma";
}

*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

img {
  display: block;
  width: 100%;
}

ol,
ul {
  list-style: none;
}

a {
  text-decoration: none;
  color: unset;
}

button,
[role=button],
a,
label,
input[type=checkbox],
input[type=file],
input[type=file]::-webkit-file-upload-button {
  cursor: pointer;
}

button:disabled,
input:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

input,
select,
button,
textarea {
  font-family: inherit;
  color: inherit;
  font-size: inherit;
}

input:focus-visible,
select:focus-visible,
button:focus-visible,
textarea:focus-visible,
a:focus-visible {
  outline: 2px solid var(--ring-color);
  outline-offset: 2px;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  box-shadow: 0 0 0px 1000px transparent inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

::placeholder {
  color: var(--text-muted);
  opacity: 0.8;
}

body {
  background-color: var(--bgc);
  color: var(--text-color);
  font-family: var(--fontFamily);
  font-size: 16px;
  line-height: 1.5;
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
}
@media only screen and (max-width: 768px) {
  body {
    background-color: var(--secondaryColor);
  }
}

.title {
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.02em;
  margin-bottom: 1.5rem;
}

.subTitle {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 1rem;
}

.status {
  display: inline-block;
  padding: 2px 10px;
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  border-radius: 100vw;
}

.approved {
  background-color: var(--approved-bgc);
  color: var(--approved-textColor);
}

.pending {
  background-color: var(--pending-bgc);
  color: var(--pending-textColor);
}

.rejected {
  background-color: var(--rejected-bgc);
  color: var(--rejected-textColor);
}

.ltr {
  direction: ltr;
  text-align: left;
}

.rtl {
  font-family: iranyekan, "IRANSans", "Tahoma";
  direction: rtl;
  text-align: right;
}

.error {
  color: var(--rejected-textColor);
}

@media only screen and (max-width: 768px) {
  .topNav_left_menu_open {
    display: block;
  }
  .topNav_left_menu_close {
    display: none;
  }
}
@media only screen and (max-width: 768px) {
  .sidebar__open .main_wrapper {
    height: 100vh;
    overflow: hidden;
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
    transform: scale(0.92) translateX(42%);
    transition: transform 200ms cubic-bezier(0.16, 1, 0.3, 1), border-radius 200ms cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: 0 12px 40px rgba(15, 23, 42, 0.18);
  }
  .sidebar__open .topNav_left_menu_open {
    display: none;
  }
  .sidebar__open .topNav_left_menu_close {
    display: block;
  }
}
@media only screen and (max-width: 576px) {
  .sidebar__open .main_wrapper {
    transform: scale(0.9) translateX(58%);
  }
}
#overlay-root > div {
  padding: 0;
}

.main_wrapper {
  transform: scale(1) translateX(0);
}

.notFound__container {
  font-family: var(--fontFamily);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
}
@media only screen and (max-width: 768px) {
  .notFound__container {
    background-color: var(--bgc);
  }
}

.notFound__container_rtl {
  font-family: iranyekan, "IRANSans", "Tahoma";
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
@media only screen and (max-width: 768px) {
  .notFound__container_rtl {
    background-color: var(--bgc);
  }
}

.notFound__title {
  font-size: 56px;
  margin: 5rem 0 3rem;
  font-family: inherit;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.1;
}
.notFound__title_rtl {
  direction: rtl;
}
@media only screen and (max-width: 768px) {
  .notFound__title {
    font-size: 36px;
    margin: 3rem;
  }
}
@media only screen and (max-width: 576px) {
  .notFound__title {
    font-size: 24px;
    margin: 1rem;
  }
}

.notFound__img {
  max-width: 500px;
  margin: 0 auto;
}

@media only screen and (max-width: 768px) {
  html[dir=rtl] .sidebar__open .main_wrapper {
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
    transform: scale(0.92) translateX(-42%);
  }
}

::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
}

::-webkit-scrollbar-track {
  background-color: var(--bgc);
}

::-webkit-scrollbar-thumb {
  background-color: var(--surface-muted);
  border-radius: 100vw;
}
::-webkit-scrollbar-thumb:hover {
  background-color: var(--text-muted);
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -30px;
}
@media only screen and (max-width: 768px) {
  .row {
    margin: 0 -8px;
  }
}

[class*=col-] {
  padding: 0 30px;
}
@media only screen and (max-width: 768px) {
  [class*=col-] {
    padding: 0 8px;
  }
}

.col-1 {
  width: 8.3333333333%;
}

.col-2 {
  width: 16.6666666667%;
}

.col-3 {
  width: 25%;
}

.col-4 {
  width: 33.3333333333%;
}

.col-5 {
  width: 41.6666666667%;
}

.col-6 {
  width: 50%;
}

.col-7 {
  width: 58.3333333333%;
}

.col-8 {
  width: 66.6666666667%;
}

.col-9 {
  width: 75%;
}

.col-10 {
  width: 83.3333333333%;
}

.col-11 {
  width: 91.6666666667%;
}

.col-12 {
  width: 100%;
}

@media only screen and (max-width: 768px) {
  .col-md-1 {
    width: 8.3333333333%;
  }
  .col-md-2 {
    width: 16.6666666667%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.3333333333%;
  }
  .col-md-5 {
    width: 41.6666666667%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.3333333333%;
  }
  .col-md-8 {
    width: 66.6666666667%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.3333333333%;
  }
  .col-md-11 {
    width: 91.6666666667%;
  }
  .col-md-12 {
    width: 100%;
  }
  .hide-md {
    display: none;
  }
}
@media only screen and (max-width: 576px) {
  .col-sm-1 {
    width: 8.3333333333%;
  }
  .col-sm-2 {
    width: 16.6666666667%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.3333333333%;
  }
  .col-sm-5 {
    width: 41.6666666667%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.3333333333%;
  }
  .col-sm-8 {
    width: 66.6666666667%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.3333333333%;
  }
  .col-sm-11 {
    width: 91.6666666667%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .hide-sm {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/App.scss","webpack://./src/scss/abstracts/_variables.scss","webpack://./src/scss/_global.scss","webpack://./src/scss/abstracts/_mixins.scss","webpack://./src/scss/_flex-grid.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,kBAAA;AAeA,mDAAA;AAIA,0BAAA;AAKA,sBAAA;AAIA,2BAAA;AAMA,8BAAA;AAOA,qBAAA;ACrCA;EACE,0DAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EAEA,uCAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;EACA,uCAAA;EACA,6BAAA;EAEA,wDAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,6CAAA;EACA,gFAAA;EACA,iDAAA;AFKF;;AEFA;EACE,uBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EAEA,uCAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;EACA,yCAAA;EACA,6BAAA;AFIF;;AEDA;EACE,6CAAA;AFIF;;AEDA;;;EAGE,SAAA;EACA,UAAA;EACA,sBAAA;AFIF;;AEDA;EACE,cAAA;EACA,WAAA;AFIF;;AEDA;;EAEE,gBAAA;AFIF;;AEDA;EACE,qBAAA;EACA,YAAA;AFIF;;AEDA;;;;;;;EAOE,eAAA;AFIF;;AEDA;;EAEE,mBAAA;EACA,aAAA;AFIF;;AEDA;;;;EAIE,oBAAA;EACA,cAAA;EACA,kBAAA;AFIF;;AEDA;;;;;EAKE,oCAAA;EACA,mBAAA;AFIF;;AEDA;;;;;;;;;EAUE,4CAAA;EACA,yDAAA;EAAA,iDAAA;AFIF;;AEDA;EACE,wBAAA;EACA,YAAA;AFIF;;AEDA;EACE,4BAAA;EACA,wBAAA;EACA,8BAAA;EACA,eDrIkB;ECsIlB,gBAAA;EACA,kBAAA;EACA,mCAAA;AFIF;AGlIE;EDuHF;IASI,uCAAA;EFMF;AACF;;AEHA;EACE,eD7IsB;EC8ItB,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AFMF;;AEHA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AFMF;;AEHA;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eDxJoB;ECyJpB,gBAAA;EACA,oBAAA;AFMF;;AEJA;EACE,qCAAA;EACA,gCAAA;AFOF;;AEJA;EACE,oCAAA;EACA,+BAAA;AFOF;;AEJA;EACE,qCAAA;EACA,gCAAA;AFOF;;AEJA;EACE,cAAA;EACA,gBAAA;AFOF;;AEJA;EACE,4CAAA;EACA,cAAA;EACA,iBAAA;AFOF;;AEJA;EACE,gCAAA;AFOF;;AG5LE;EDyLA;IACE,cAAA;EFOF;EEJA;IACE,aAAA;EFMF;AACF;AGrME;EDmMA;IACE,aAAA;IACA,gBAAA;IACA,4BAAA;IACA,+BAAA;IACA,sCAAA;IACA,4GAAA;IACA,8CDxMc;ED6MhB;EEFA;IACE,aAAA;EFIF;EEDA;IACE,cAAA;EFGF;AACF;AG5NE;ED6NA;IACE,qCAAA;EFEF;AACF;AECA;EACE,UAAA;AFCF;;AEEA;EACE,iCAAA;AFCF;;AEEA;EACE,8BAAA;ECjPA,aAAA;EACA,mBAFsB;EAGtB,uBAH+C;EDoP/C,sBAAA;EACA,WAAA;EACA,iBAAA;AFGF;AG5OE;EDoOF;IAOI,4BAAA;EFKF;AACF;;AEFA;EACE,4CAAA;EACA,iBAAA;EC7PA,aAAA;EACA,mBAFsB;EAGtB,uBAH+C;EDgQ/C,sBAAA;AFOF;AG1PE;ED+OF;IAMI,4BAAA;EFSF;AACF;;AENA;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AFSF;AERE;EACE,cAAA;AFUJ;AG3QE;EDyPF;IAYI,eAAA;IACA,YAAA;EFUF;AACF;AGvRE;ED+PF;IAgBI,eAAA;IACA,YAAA;EFYF;AACF;;AETA;EACE,gBAAA;EACA,cAAA;AFYF;;AG5RE;EDqRE;IACE,6BAAA;IACA,gCAAA;IACA,uCAAA;EFWJ;AACF;;AEPA;EACE,aAAA;EACA,cAAA;AFUF;;AEPA;EACE,4BAAA;AFUF;;AEPA;EACE,sCAAA;EACA,oBAAA;AFUF;AETE;EACE,mCAAA;AFWJ;;AEPA;EACE;;;IAGE,qCAAA;IACA,uCAAA;IACA,sCAAA;IACA,gCAAA;EFUF;AACF;AI5UA;EACE,aAAA;EACA,eAAA;EACA,eAAA;AJ8UF;AGrUE;ECZF;IAMI,cAAA;EJ+UF;AACF;;AI5UA;EACE,eAAA;AJ+UF;AG9UE;ECFF;IAII,cAAA;EJgVF;AACF;;AI3UE;EACE,oBAAA;AJ8UJ;;AI/UE;EACE,qBAAA;AJkVJ;;AInVE;EACE,UAAA;AJsVJ;;AIvVE;EACE,qBAAA;AJ0VJ;;AI3VE;EACE,qBAAA;AJ8VJ;;AI/VE;EACE,UAAA;AJkWJ;;AInWE;EACE,qBAAA;AJsWJ;;AIvWE;EACE,qBAAA;AJ0WJ;;AI3WE;EACE,UAAA;AJ8WJ;;AI/WE;EACE,qBAAA;AJkXJ;;AInXE;EACE,qBAAA;AJsXJ;;AIvXE;EACE,WAAA;AJ0XJ;;AGnYE;ECkBE;IACE,oBAAA;EJqXJ;EItXE;IACE,qBAAA;EJwXJ;EIzXE;IACE,UAAA;EJ2XJ;EI5XE;IACE,qBAAA;EJ8XJ;EI/XE;IACE,qBAAA;EJiYJ;EIlYE;IACE,UAAA;EJoYJ;EIrYE;IACE,qBAAA;EJuYJ;EIxYE;IACE,qBAAA;EJ0YJ;EI3YE;IACE,UAAA;EJ6YJ;EI9YE;IACE,qBAAA;EJgZJ;EIjZE;IACE,qBAAA;EJmZJ;EIpZE;IACE,WAAA;EJsZJ;EIlZA;IACE,aAAA;EJoZF;AACF;AGnbE;ECuCE;IACE,oBAAA;EJ+YJ;EIhZE;IACE,qBAAA;EJkZJ;EInZE;IACE,UAAA;EJqZJ;EItZE;IACE,qBAAA;EJwZJ;EIzZE;IACE,qBAAA;EJ2ZJ;EI5ZE;IACE,UAAA;EJ8ZJ;EI/ZE;IACE,qBAAA;EJiaJ;EIlaE;IACE,qBAAA;EJoaJ;EIraE;IACE,UAAA;EJuaJ;EIxaE;IACE,qBAAA;EJ0aJ;EI3aE;IACE,qBAAA;EJ6aJ;EI9aE;IACE,WAAA;EJgbJ;EI5aA;IACE,aAAA;EJ8aF;AACF","sourcesContent":["@charset \"UTF-8\";\n@import url(../assets/fonts/css/fontiran.css);\n@import url(\"https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400&display=swap\");\n/* ****Fonts**** */\n/* ****Shadows (subtle elevation — flat SaaS)**** */\n/* ****Border radius**** */\n/* ****icon size**** */\n/* **** Device width **** */\n/* **** helper variable **** */\n/* **** Motion **** */\nhtml {\n  /* Trafertir design tokens — professional navy + sky CTA */\n  --primaryColor: #0369a1;\n  --secondaryColor: #0f172a;\n  --accentColor: #0284c7;\n  --bgc: #f8fafc;\n  --card-bgc: #ffffff;\n  --surface-muted: #e8ecf1;\n  --text-color: #020617;\n  --text-muted: #64748b;\n  --border-color: #e2e8f0;\n  --ring-color: #0f172a;\n  --destructive: #dc2626;\n  --approved-bgc: rgba(34, 197, 94, 0.15);\n  --approved-textColor: #166534;\n  --pending-bgc: rgba(14, 165, 233, 0.15);\n  --pending-textColor: #075985;\n  --rejected-bgc: rgba(220, 38, 38, 0.15);\n  --rejected-textColor: #991b1b;\n  --fontFamily: \"Plus Jakarta Sans\", system-ui, sans-serif;\n  --radius-sm: 8px;\n  --radius-md: 12px;\n  --radius-lg: 16px;\n  --shadow-sm: 0 1px 2px rgba(15, 23, 42, 0.05);\n  --shadow-md: 0 1px 2px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.06);\n  --transition: 200ms cubic-bezier(0.16, 1, 0.3, 1);\n}\n\nhtml[theme=dark] {\n  --primaryColor: #38bdf8;\n  --secondaryColor: #e2e8f0;\n  --accentColor: #7dd3fc;\n  --bgc: #0f172a;\n  --card-bgc: #1e293b;\n  --surface-muted: #334155;\n  --text-color: #f8fafc;\n  --text-muted: #94a3b8;\n  --border-color: #334155;\n  --ring-color: #38bdf8;\n  --approved-bgc: rgba(34, 197, 94, 0.22);\n  --approved-textColor: #bbf7d0;\n  --pending-bgc: rgba(56, 189, 248, 0.22);\n  --pending-textColor: #bae6fd;\n  --rejected-bgc: rgba(248, 113, 113, 0.22);\n  --rejected-textColor: #fecaca;\n}\n\nhtml[dir=rtl] {\n  --fontFamily: iranyekan, \"IRANSans\", \"Tahoma\";\n}\n\n*,\n*::before,\n*::after {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nimg {\n  display: block;\n  width: 100%;\n}\n\nol,\nul {\n  list-style: none;\n}\n\na {\n  text-decoration: none;\n  color: unset;\n}\n\nbutton,\n[role=button],\na,\nlabel,\ninput[type=checkbox],\ninput[type=file],\ninput[type=file]::-webkit-file-upload-button {\n  cursor: pointer;\n}\n\nbutton:disabled,\ninput:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\ninput,\nselect,\nbutton,\ntextarea {\n  font-family: inherit;\n  color: inherit;\n  font-size: inherit;\n}\n\ninput:focus-visible,\nselect:focus-visible,\nbutton:focus-visible,\ntextarea:focus-visible,\na:focus-visible {\n  outline: 2px solid var(--ring-color);\n  outline-offset: 2px;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0px 1000px transparent inset;\n  box-shadow: 0 0 0px 1000px transparent inset;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n::placeholder {\n  color: var(--text-muted);\n  opacity: 0.8;\n}\n\nbody {\n  background-color: var(--bgc);\n  color: var(--text-color);\n  font-family: var(--fontFamily);\n  font-size: 16px;\n  line-height: 1.5;\n  overflow-x: hidden;\n  -webkit-font-smoothing: antialiased;\n}\n@media only screen and (max-width: 768px) {\n  body {\n    background-color: var(--secondaryColor);\n  }\n}\n\n.title {\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.3;\n  letter-spacing: -0.02em;\n  margin-bottom: 1.5rem;\n}\n\n.subTitle {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.status {\n  display: inline-block;\n  padding: 2px 10px;\n  text-align: center;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 100vw;\n}\n\n.approved {\n  background-color: var(--approved-bgc);\n  color: var(--approved-textColor);\n}\n\n.pending {\n  background-color: var(--pending-bgc);\n  color: var(--pending-textColor);\n}\n\n.rejected {\n  background-color: var(--rejected-bgc);\n  color: var(--rejected-textColor);\n}\n\n.ltr {\n  direction: ltr;\n  text-align: left;\n}\n\n.rtl {\n  font-family: iranyekan, \"IRANSans\", \"Tahoma\";\n  direction: rtl;\n  text-align: right;\n}\n\n.error {\n  color: var(--rejected-textColor);\n}\n\n@media only screen and (max-width: 768px) {\n  .topNav_left_menu_open {\n    display: block;\n  }\n  .topNav_left_menu_close {\n    display: none;\n  }\n}\n@media only screen and (max-width: 768px) {\n  .sidebar__open .main_wrapper {\n    height: 100vh;\n    overflow: hidden;\n    border-top-left-radius: 24px;\n    border-bottom-left-radius: 24px;\n    transform: scale(0.92) translateX(42%);\n    transition: transform 200ms cubic-bezier(0.16, 1, 0.3, 1), border-radius 200ms cubic-bezier(0.16, 1, 0.3, 1);\n    box-shadow: 0 12px 40px rgba(15, 23, 42, 0.18);\n  }\n  .sidebar__open .topNav_left_menu_open {\n    display: none;\n  }\n  .sidebar__open .topNav_left_menu_close {\n    display: block;\n  }\n}\n@media only screen and (max-width: 576px) {\n  .sidebar__open .main_wrapper {\n    transform: scale(0.9) translateX(58%);\n  }\n}\n#overlay-root > div {\n  padding: 0;\n}\n\n.main_wrapper {\n  transform: scale(1) translateX(0);\n}\n\n.notFound__container {\n  font-family: var(--fontFamily);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n  min-height: 100vh;\n}\n@media only screen and (max-width: 768px) {\n  .notFound__container {\n    background-color: var(--bgc);\n  }\n}\n\n.notFound__container_rtl {\n  font-family: iranyekan, \"IRANSans\", \"Tahoma\";\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n@media only screen and (max-width: 768px) {\n  .notFound__container_rtl {\n    background-color: var(--bgc);\n  }\n}\n\n.notFound__title {\n  font-size: 56px;\n  margin: 5rem 0 3rem;\n  font-family: inherit;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.1;\n}\n.notFound__title_rtl {\n  direction: rtl;\n}\n@media only screen and (max-width: 768px) {\n  .notFound__title {\n    font-size: 36px;\n    margin: 3rem;\n  }\n}\n@media only screen and (max-width: 576px) {\n  .notFound__title {\n    font-size: 24px;\n    margin: 1rem;\n  }\n}\n\n.notFound__img {\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n@media only screen and (max-width: 768px) {\n  html[dir=rtl] .sidebar__open .main_wrapper {\n    border-top-right-radius: 24px;\n    border-bottom-right-radius: 24px;\n    transform: scale(0.92) translateX(-42%);\n  }\n}\n\n::-webkit-scrollbar {\n  width: 0.5rem;\n  height: 0.5rem;\n}\n\n::-webkit-scrollbar-track {\n  background-color: var(--bgc);\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: var(--surface-muted);\n  border-radius: 100vw;\n}\n::-webkit-scrollbar-thumb:hover {\n  background-color: var(--text-muted);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -30px;\n}\n@media only screen and (max-width: 768px) {\n  .row {\n    margin: 0 -8px;\n  }\n}\n\n[class*=col-] {\n  padding: 0 30px;\n}\n@media only screen and (max-width: 768px) {\n  [class*=col-] {\n    padding: 0 8px;\n  }\n}\n\n.col-1 {\n  width: 8.3333333333%;\n}\n\n.col-2 {\n  width: 16.6666666667%;\n}\n\n.col-3 {\n  width: 25%;\n}\n\n.col-4 {\n  width: 33.3333333333%;\n}\n\n.col-5 {\n  width: 41.6666666667%;\n}\n\n.col-6 {\n  width: 50%;\n}\n\n.col-7 {\n  width: 58.3333333333%;\n}\n\n.col-8 {\n  width: 66.6666666667%;\n}\n\n.col-9 {\n  width: 75%;\n}\n\n.col-10 {\n  width: 83.3333333333%;\n}\n\n.col-11 {\n  width: 91.6666666667%;\n}\n\n.col-12 {\n  width: 100%;\n}\n\n@media only screen and (max-width: 768px) {\n  .col-md-1 {\n    width: 8.3333333333%;\n  }\n  .col-md-2 {\n    width: 16.6666666667%;\n  }\n  .col-md-3 {\n    width: 25%;\n  }\n  .col-md-4 {\n    width: 33.3333333333%;\n  }\n  .col-md-5 {\n    width: 41.6666666667%;\n  }\n  .col-md-6 {\n    width: 50%;\n  }\n  .col-md-7 {\n    width: 58.3333333333%;\n  }\n  .col-md-8 {\n    width: 66.6666666667%;\n  }\n  .col-md-9 {\n    width: 75%;\n  }\n  .col-md-10 {\n    width: 83.3333333333%;\n  }\n  .col-md-11 {\n    width: 91.6666666667%;\n  }\n  .col-md-12 {\n    width: 100%;\n  }\n  .hide-md {\n    display: none;\n  }\n}\n@media only screen and (max-width: 576px) {\n  .col-sm-1 {\n    width: 8.3333333333%;\n  }\n  .col-sm-2 {\n    width: 16.6666666667%;\n  }\n  .col-sm-3 {\n    width: 25%;\n  }\n  .col-sm-4 {\n    width: 33.3333333333%;\n  }\n  .col-sm-5 {\n    width: 41.6666666667%;\n  }\n  .col-sm-6 {\n    width: 50%;\n  }\n  .col-sm-7 {\n    width: 58.3333333333%;\n  }\n  .col-sm-8 {\n    width: 66.6666666667%;\n  }\n  .col-sm-9 {\n    width: 75%;\n  }\n  .col-sm-10 {\n    width: 83.3333333333%;\n  }\n  .col-sm-11 {\n    width: 91.6666666667%;\n  }\n  .col-sm-12 {\n    width: 100%;\n  }\n  .hide-sm {\n    display: none;\n  }\n}","/* ****Fonts**** */\r\n\r\n//Body size\r\n$fontSizeBodySmall: 12px;\r\n$fontSizeBodyMedium: 14px;\r\n$fontSizeBodyLarge: 16px;\r\n//Headline size\r\n$fontSizeHeadlineSmall: 24px;\r\n$fontSizeHeadlineMedium: 36px;\r\n$fontSizeHeadlineLarge: 48px;\r\n//Display size\r\n$fontSizeDisplaySmall: 56px;\r\n//helper font size\r\n$fontSizeTableStatus: 11px;\r\n\r\n/* ****Shadows (subtle elevation — flat SaaS)**** */\r\n$mainBoxShadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.06);\r\n$secondBoxShadow: 0 12px 40px rgba(15, 23, 42, 0.18);\r\n\r\n/* ****Border radius**** */\r\n$smallBorderRadius: 8px;\r\n$mediumBorderRadius: 12px;\r\n$largeBorderRadius: 16px;\r\n\r\n/* ****icon size**** */\r\n$smallIconSize: 20px;\r\n$largeIconSize: 48px;\r\n\r\n/* **** Device width **** */\r\n$mobile-width: 576px;\r\n$tablet-width: 768px;\r\n$desktop-width: 992px;\r\n$largeDesktop-width: 1200px;\r\n\r\n/* **** helper variable **** */\r\n$sideBarOpenWidth: 248px;\r\n$sideBarCloseWidth: 72px;\r\n$spacing: 60px;\r\n$mobileSpacing: 16px;\r\n$sideBarLogoHeight: 171px;\r\n\r\n/* **** Motion **** */\r\n$ease-out: cubic-bezier(0.16, 1, 0.3, 1);\r\n$duration-fast: 150ms;\r\n$duration-base: 200ms;\r\n","@use \"./abstracts/\" as *;\r\n@import url(../assets/fonts/css/fontiran.css);\r\n@import url(\"https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400&display=swap\");\r\n\r\nhtml {\r\n  /* Trafertir design tokens — professional navy + sky CTA */\r\n  --primaryColor: #0369a1;\r\n  --secondaryColor: #0f172a;\r\n  --accentColor: #0284c7;\r\n  --bgc: #f8fafc;\r\n  --card-bgc: #ffffff;\r\n  --surface-muted: #e8ecf1;\r\n  --text-color: #020617;\r\n  --text-muted: #64748b;\r\n  --border-color: #e2e8f0;\r\n  --ring-color: #0f172a;\r\n  --destructive: #dc2626;\r\n\r\n  --approved-bgc: rgba(34, 197, 94, 0.15);\r\n  --approved-textColor: #166534;\r\n  --pending-bgc: rgba(14, 165, 233, 0.15);\r\n  --pending-textColor: #075985;\r\n  --rejected-bgc: rgba(220, 38, 38, 0.15);\r\n  --rejected-textColor: #991b1b;\r\n\r\n  --fontFamily: \"Plus Jakarta Sans\", system-ui, sans-serif;\r\n  --radius-sm: #{$smallBorderRadius};\r\n  --radius-md: #{$mediumBorderRadius};\r\n  --radius-lg: #{$largeBorderRadius};\r\n  --shadow-sm: 0 1px 2px rgba(15, 23, 42, 0.05);\r\n  --shadow-md: #{$mainBoxShadow};\r\n  --transition: #{$duration-base} #{$ease-out};\r\n}\r\n\r\nhtml[theme=\"dark\"] {\r\n  --primaryColor: #38bdf8;\r\n  --secondaryColor: #e2e8f0;\r\n  --accentColor: #7dd3fc;\r\n  --bgc: #0f172a;\r\n  --card-bgc: #1e293b;\r\n  --surface-muted: #334155;\r\n  --text-color: #f8fafc;\r\n  --text-muted: #94a3b8;\r\n  --border-color: #334155;\r\n  --ring-color: #38bdf8;\r\n\r\n  --approved-bgc: rgba(34, 197, 94, 0.22);\r\n  --approved-textColor: #bbf7d0;\r\n  --pending-bgc: rgba(56, 189, 248, 0.22);\r\n  --pending-textColor: #bae6fd;\r\n  --rejected-bgc: rgba(248, 113, 113, 0.22);\r\n  --rejected-textColor: #fecaca;\r\n}\r\n\r\nhtml[dir=\"rtl\"] {\r\n  --fontFamily: iranyekan, \"IRANSans\", \"Tahoma\";\r\n}\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nimg {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\nol,\r\nul {\r\n  list-style: none;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n  color: unset;\r\n}\r\n\r\nbutton,\r\n[role=\"button\"],\r\na,\r\nlabel,\r\ninput[type=\"checkbox\"],\r\ninput[type=\"file\"],\r\ninput[type=\"file\"]::-webkit-file-upload-button {\r\n  cursor: pointer;\r\n}\r\n\r\nbutton:disabled,\r\ninput:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.55;\r\n}\r\n\r\ninput,\r\nselect,\r\nbutton,\r\ntextarea {\r\n  font-family: inherit;\r\n  color: inherit;\r\n  font-size: inherit;\r\n}\r\n\r\ninput:focus-visible,\r\nselect:focus-visible,\r\nbutton:focus-visible,\r\ntextarea:focus-visible,\r\na:focus-visible {\r\n  outline: 2px solid var(--ring-color);\r\n  outline-offset: 2px;\r\n}\r\n\r\ninput:-webkit-autofill,\r\ninput:-webkit-autofill:hover,\r\ninput:-webkit-autofill:focus,\r\ntextarea:-webkit-autofill,\r\ntextarea:-webkit-autofill:hover,\r\ntextarea:-webkit-autofill:focus,\r\nselect:-webkit-autofill,\r\nselect:-webkit-autofill:hover,\r\nselect:-webkit-autofill:focus {\r\n  -webkit-box-shadow: 0 0 0px 1000px transparent inset;\r\n  box-shadow: 0 0 0px 1000px transparent inset;\r\n  transition: background-color 5000s ease-in-out 0s;\r\n}\r\n\r\n::placeholder {\r\n  color: var(--text-muted);\r\n  opacity: 0.8;\r\n}\r\n\r\nbody {\r\n  background-color: var(--bgc);\r\n  color: var(--text-color);\r\n  font-family: var(--fontFamily);\r\n  font-size: $fontSizeBodyLarge;\r\n  line-height: 1.5;\r\n  overflow-x: hidden;\r\n  -webkit-font-smoothing: antialiased;\r\n  @include tablet {\r\n    background-color: var(--secondaryColor);\r\n  }\r\n}\r\n\r\n.title {\r\n  font-size: $fontSizeHeadlineSmall;\r\n  font-weight: 700;\r\n  line-height: 1.3;\r\n  letter-spacing: -0.02em;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.subTitle {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.status {\r\n  display: inline-block;\r\n  padding: 2px 10px;\r\n  text-align: center;\r\n  font-size: $fontSizeTableStatus;\r\n  font-weight: 600;\r\n  border-radius: 100vw;\r\n}\r\n.approved {\r\n  background-color: var(--approved-bgc);\r\n  color: var(--approved-textColor);\r\n}\r\n\r\n.pending {\r\n  background-color: var(--pending-bgc);\r\n  color: var(--pending-textColor);\r\n}\r\n\r\n.rejected {\r\n  background-color: var(--rejected-bgc);\r\n  color: var(--rejected-textColor);\r\n}\r\n\r\n.ltr {\r\n  direction: ltr;\r\n  text-align: left;\r\n}\r\n\r\n.rtl {\r\n  font-family: iranyekan, \"IRANSans\", \"Tahoma\";\r\n  direction: rtl;\r\n  text-align: right;\r\n}\r\n\r\n.error {\r\n  color: var(--rejected-textColor);\r\n}\r\n\r\n@include tablet {\r\n  .topNav_left_menu_open {\r\n    display: block;\r\n  }\r\n\r\n  .topNav_left_menu_close {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@include tablet {\r\n  .sidebar__open .main_wrapper {\r\n    height: 100vh;\r\n    overflow: hidden;\r\n    border-top-left-radius: 24px;\r\n    border-bottom-left-radius: 24px;\r\n    transform: scale(0.92) translateX(42%);\r\n    transition: transform $duration-base $ease-out, border-radius $duration-base $ease-out;\r\n    box-shadow: $secondBoxShadow;\r\n  }\r\n\r\n  .sidebar__open .topNav_left_menu_open {\r\n    display: none;\r\n  }\r\n\r\n  .sidebar__open .topNav_left_menu_close {\r\n    display: block;\r\n  }\r\n}\r\n\r\n@include mobile {\r\n  .sidebar__open .main_wrapper {\r\n    transform: scale(0.9) translateX(58%);\r\n  }\r\n}\r\n\r\n#overlay-root > div {\r\n  padding: 0;\r\n}\r\n\r\n.main_wrapper {\r\n  transform: scale(1) translateX(0);\r\n}\r\n\r\n.notFound__container {\r\n  font-family: var(--fontFamily);\r\n  @include flex();\r\n  flex-direction: column;\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  @include tablet {\r\n    background-color: var(--bgc);\r\n  }\r\n}\r\n\r\n.notFound__container_rtl {\r\n  font-family: iranyekan, \"IRANSans\", \"Tahoma\";\r\n  min-height: 100vh;\r\n  @include flex();\r\n  flex-direction: column;\r\n  @include tablet {\r\n    background-color: var(--bgc);\r\n  }\r\n}\r\n\r\n.notFound__title {\r\n  font-size: 56px;\r\n  margin: 5rem 0 3rem;\r\n  font-family: inherit;\r\n  font-weight: 800;\r\n  letter-spacing: -0.03em;\r\n  line-height: 1.1;\r\n  &_rtl {\r\n    direction: rtl;\r\n  }\r\n\r\n  @include tablet {\r\n    font-size: 36px;\r\n    margin: 3rem;\r\n  }\r\n  @include mobile {\r\n    font-size: 24px;\r\n    margin: 1rem;\r\n  }\r\n}\r\n\r\n.notFound__img {\r\n  max-width: 500px;\r\n  margin: 0 auto;\r\n}\r\n\r\nhtml[dir=\"rtl\"] {\r\n  @include tablet {\r\n    .sidebar__open .main_wrapper {\r\n      border-top-right-radius: 24px;\r\n      border-bottom-right-radius: 24px;\r\n      transform: scale(0.92) translateX(-42%);\r\n    }\r\n  }\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  width: 0.5rem;\r\n  height: 0.5rem;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background-color: var(--bgc);\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background-color: var(--surface-muted);\r\n  border-radius: 100vw;\r\n  &:hover {\r\n    background-color: var(--text-muted);\r\n  }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n    scroll-behavior: auto !important;\r\n  }\r\n}\r\n","@use './variables' as *;\r\n\r\n@mixin flex($alignItem: center, $justifyContent: center) {\r\n  display: flex;\r\n  align-items: $alignItem;\r\n  justify-content: $justifyContent;\r\n}\r\n\r\n@mixin mobile {\r\n  @media only screen and (max-width: $mobile-width) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin tablet {\r\n  @media only screen and (max-width: $tablet-width) {\r\n    @content;\r\n  }\r\n}\r\n","@use './abstracts/' as *;\r\n@use 'sass:math';\r\n\r\n.row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin: 0 math.div($spacing, 2) * -1;\r\n\r\n  @include tablet {\r\n    margin: 0 math.div($mobileSpacing, 2) * -1;\r\n  }\r\n}\r\n\r\n[class*=\"col-\"] {\r\n  padding: 0 math.div($spacing, 2);\r\n\r\n  @include tablet {\r\n    padding: 0 math.div($mobileSpacing, 2);\r\n  }\r\n}\r\n\r\n@for $i from 1 through 12 {\r\n  $v: math.div($i, 12) * 100;\r\n  .col-#{$i} {\r\n    width: $v * 1%;\r\n  }\r\n}\r\n\r\n// medium screen\r\n\r\n@include tablet {\r\n  @for $i from 1 through 12 {\r\n    $v: math.div($i, 12) * 100;\r\n    .col-md-#{$i} {\r\n      width: $v * 1%;\r\n    }\r\n  }\r\n\r\n  .hide-md {\r\n    display: none;\r\n  }\r\n}\r\n\r\n// small screen\r\n\r\n@include mobile {\r\n  @for $i from 1 through 12 {\r\n    $v: math.div($i, 12) * 100;\r\n    .col-sm-#{$i} {\r\n      width: $v * 1%;\r\n    }\r\n  }\r\n\r\n  .hide-sm {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
